export enum AdditionalItemStatus {
    IN_PROGRESS = 'IN_PROGRESS',
    ACCEPTED = 'ACCEPTED',
    CHARGED = 'CHARGED',
    DECLINED = 'DECLINED'
}



// WEBPACK FOOTER //
// ./src/types/enums/AdditionalItemStatus.ts